import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { trackUserJourney } from '../utils/datadog';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = 'Bitsburg Bank - Error';

    // Track user journey step - error page indicates something went wrong
    trackUserJourney('error_page_visited', {
      previous_page: document.referrer || 'direct',
      error_context: 'user_reached_error_page',
      timestamp: new Date().toISOString(),
    });
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="bank-card bank-card-elevated bank-card-no-hover text-center">
              <div className="bank-card-body py-5">
                <div className="mb-4">
                  <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '4rem' }}></i>
                </div>

                <h1 className="mb-3 fw-bold text-dark">Oops! Something went wrong</h1>
                <p className="lead text-muted mb-4">
                  We're sorry, but we encountered an unexpected error while processing your request. Our technical team
                  has been automatically notified and is working to resolve this issue.
                </p>

                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                  <Link to="/" className="btn bank-btn-primary">
                    <i className="bi bi-house me-2"></i>
                    GO TO HOME PAGE
                  </Link>
                  <button onClick={handleGoBack} className="btn bank-btn-outline">
                    <i className="bi bi-arrow-left me-2"></i>
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
